import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['triggerBtn', 'shareContainer'];

    triggerBtnTargetConnected(triggerBtn) {
        triggerBtn.addEventListener('click', () => {
            this.shareContainerTarget.classList.toggle("share-container-show");
        })
    }
}